import { render, staticRenderFns } from "./OrdresProfessionnels.vue?vue&type=template&id=70d47fcc"
import script from "./OrdresProfessionnels.vue?vue&type=script&lang=js"
export * from "./OrdresProfessionnels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports